// Third-party
import React from 'react';

// Utils
import { formatLocalizedString, formatMessageWithLocale } from '@/utils/i18n';
import HoldingIcon from '../../common/HoldingIcon';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import ComparisonItemType from '@/types/comparison-item-type';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const RiskProfileMayDifferDisclaimer = ({ items, showItemNames, locale }: Props) => {
  const currentItem = items.find(item => item.flags?.includes('proposalItemPurpose_current'));
  const recommendedItems = items.filter(item => item.flags?.includes('proposalItemPurpose_recommended'));

  const getHoldingIcon = (type: ComparisonItemType, color?: string) => (!color ? null : <HoldingIcon type={type} color={color} />);

  const addPortfolioItemName = (item: ComparisonItem) => (
    <>
      <span className="item-name">
        {getHoldingIcon(item.type, item.color)}
        {formatLocalizedString(item.name, locale)}
      </span>
      {recommendedItems.length > 1 && item !== currentItem && recommendedItems.indexOf(item) !== recommendedItems.length - 1 && ', '}
    </>
  );

  return (
    <div className="disclaimer">
      {currentItem && recommendedItems.length && (
        <div className="disclaimer-item">
          {formatMessageWithLocale('Disclaimers.RiskProfileMayDifferDisclaimer.RiskProfileOf', locale)}
          {addPortfolioItemName(currentItem)}
          {` ${formatMessageWithLocale('Common.And', locale)} `}
          {recommendedItems.map(item => addPortfolioItemName(item))} {formatMessageWithLocale('Disclaimers.RiskProfileMayDifferDisclaimer.MayDiffer', locale)}
        </div>
      )}
    </div>
  );
};

export default RiskProfileMayDifferDisclaimer;
